import './style.less';
import adminEmployeesModalActivitiesController from 'modals/employeesActivities/';
import adminEmployeesModalActivitiesTemplate from 'modals/employeesActivities/index.html';

export default function($log, $scope, $stateParams, $location, $uibModal, $state, ResolveClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.stateParams = $stateParams;

  vm.isManageRoute = ResolveClass.isManageRoute();

  const profile_uid = vm.isManageRoute ? $stateParams.employeeID : $stateParams.id;

  switch ($stateParams.tab) {
    case 'all':
      vm.activeTab = 1;
      break;
    default:
      vm.activeTab = 0;
  }

  vm.changeTab = tab => $location.search('tab', tab);

  vm.assignActivity = () => {
    const modalInstance = $uibModal.open({
      backdrop: true,
      size: 'lg',
      template: adminEmployeesModalActivitiesTemplate,
      controller: adminEmployeesModalActivitiesController,
      resolve: {
        selectedEmployees: function() {
          return [{ profile_uid }];
        }
      }
    });

    modalInstance.result.then($state.reload);
  };

  function activate() {
    $log.debug('Users Learning Activities Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/learning/activities/index.js